module.exports = __webpack_public_path__ + "img/buono_pasto_Welfarebit-Toduba.0f1ae9f3.jpg";